var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("CriterionDetailsDialog", {
        attrs: { viewModel: _vm.criterionDetailsDialog },
      }),
      _vm._v(" "),
      _vm.viewTemplate === "default"
        ? [
            _c(
              "nav",
              {
                staticClass:
                  "navbar navbar-expand-md navbar-dark bg-dark fixed-top",
              },
              [
                _c("div", { staticClass: "container" }, [
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "sanitizedHref",
                          rawName: "v-sanitizedHref",
                          value: _vm.dashboardUrl,
                          expression: "dashboardUrl",
                        },
                      ],
                      staticClass: "btn btn-light mr-auto",
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-angle-double-left",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(
                        "\n                    My Survey\n                "
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "container",
                staticStyle: { "padding-top": "80px" },
              },
              [
                _vm.question
                  ? _c("div", { attrs: { id: "MeetingQuestion" } }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "min-height": "100vh",
                            "margin-top": "80px",
                          },
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "text-center lead",
                              staticStyle: { "font-size": "1.5rem" },
                            },
                            [
                              _vm._v(
                                "\n                        In the context of "
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "text-primary",
                                  attrs: { title: "Show details" },
                                  on: {
                                    click: _vm.showContextCriterionDetails,
                                  },
                                },
                                [_vm._v(_vm._s(_vm.contextName))]
                              ),
                              _vm._v(
                                ",\n                        which criterion is more important: "
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "text-primary",
                                  attrs: { title: "Show details" },
                                  on: { click: _vm.showFirstCriterionDetails },
                                },
                                [_vm._v(_vm._s(_vm.firstCriterionName))]
                              ),
                              _vm._v(" or\n                        "),
                              _c(
                                "a",
                                {
                                  staticClass: "text-primary",
                                  attrs: { title: "Show details" },
                                  on: { click: _vm.showSecondCriterionDetails },
                                },
                                [_vm._v(_vm._s(_vm.secondCriterionName))]
                              ),
                              _vm._v("?\n                    "),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticStyle: { "min-height": "450px" } },
                            [
                              _c(
                                "div",
                                { staticClass: "PairwiseComparisonEditor" },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-lg-6 col-md-6 col-sm-6 col-xs-12",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "mt1 ItemDetailsBox bg-color-blue3",
                                          },
                                          [
                                            _c("h4", [
                                              _vm._v(
                                                _vm._s(_vm.firstCriterionName)
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "btn-group ItemButton",
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-block dropdown-toggle",
                                                class: _vm.FirstSelected
                                                  ? "btn-success"
                                                  : "btn-outline-secondary",
                                                attrs: {
                                                  type: "button",
                                                  "data-toggle": "dropdown",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa-regular",
                                                  class: _vm.FirstSelected
                                                    ? "fa-square-check"
                                                    : "fa-square",
                                                  attrs: {
                                                    "aria-hidden": "true",
                                                  },
                                                }),
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(_vm.FirstBtnLabel) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "dropdown-menu" },
                                              [
                                                _c(
                                                  "h4",
                                                  {
                                                    staticClass:
                                                      "dropdown-header",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "How much more important?"
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticClass:
                                                    "dropdown-divider",
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleSavePanelistVoteCommand(
                                                          2
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Weak (2)")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleSavePanelistVoteCommand(
                                                          3
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Moderate (3)")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleSavePanelistVoteCommand(
                                                          4
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Moderate + (4)")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleSavePanelistVoteCommand(
                                                          5
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Strong (5)")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleSavePanelistVoteCommand(
                                                          6
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Strong + (6)")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleSavePanelistVoteCommand(
                                                          7
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Very strong (7)")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleSavePanelistVoteCommand(
                                                          8
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Very strong + (8)")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleSavePanelistVoteCommand(
                                                          9
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Extreme (9)")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-lg-6 col-md-6 col-sm-6 col-xs-12",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "mt1 ItemDetailsBox bg-color-red3",
                                          },
                                          [
                                            _c("h4", [
                                              _vm._v(
                                                _vm._s(_vm.secondCriterionName)
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "btn-group ItemButton",
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-block dropdown-toggle",
                                                class: _vm.SecondSelected
                                                  ? "btn-success"
                                                  : "btn-outline-secondary",
                                                attrs: {
                                                  type: "button",
                                                  "data-toggle": "dropdown",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa-regular",
                                                  class: _vm.SecondSelected
                                                    ? "fa-square-check"
                                                    : "fa-square",
                                                  attrs: {
                                                    "aria-hidden": "true",
                                                  },
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(_vm.SecondBtnLabel) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "dropdown-menu" },
                                              [
                                                _c(
                                                  "h4",
                                                  {
                                                    staticClass:
                                                      "dropdown-header",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "How much more important?"
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticClass:
                                                    "dropdown-divider",
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleSavePanelistVoteCommand(
                                                          1.0 / 2.0
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Weak (2)")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleSavePanelistVoteCommand(
                                                          1.0 / 3.0
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Moderate (3)")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleSavePanelistVoteCommand(
                                                          1.0 / 4.0
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Moderate + (4)")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleSavePanelistVoteCommand(
                                                          1.0 / 5.0
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Strong (5)")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleSavePanelistVoteCommand(
                                                          1.0 / 6.0
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Strong + (6)")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleSavePanelistVoteCommand(
                                                          1.0 / 7.0
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Very strong (7)")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleSavePanelistVoteCommand(
                                                          1.0 / 8.0
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Very strong + (8)")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleSavePanelistVoteCommand(
                                                          1.0 / 9.0
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Extreme (9)")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-lg-6 offset-lg-3 col-md-6 offset-md-3 col-sm-6 offset-sm-3 col-xs-12",
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-block btn-equal mt1",
                                            class:
                                              _vm.EqualitySelected === true
                                                ? "btn-success"
                                                : "btn-outline-secondary",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleSavePanelistVoteCommand(
                                                  1.0
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa-regular",
                                              class:
                                                _vm.EqualitySelected === true
                                                  ? "fa-square-check"
                                                  : "fa-square",
                                              attrs: { "aria-hidden": "true" },
                                            }),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v("Equally important (1)"),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-lg-6 offset-lg-3 col-md-6 offset-md-3 col-sm-6 offset-sm-3 col-xs-12",
                                      },
                                      [
                                        _vm.Value != null
                                          ? _c(
                                              "div",
                                              { staticClass: "text-center" },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-link mt1",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleSavePanelistVoteCommand(
                                                          null
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-times",
                                                      attrs: {
                                                        "aria-hidden": "true",
                                                      },
                                                    }),
                                                    _vm._v(
                                                      " Clear answer\n                                        "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticStyle: { "margin-top": "30px" } },
                                    [
                                      _c(
                                        "h5",
                                        {
                                          staticStyle: {
                                            "margin-bottom": "5px",
                                          },
                                        },
                                        [_vm._v("Comment:")]
                                      ),
                                      _vm._v(" "),
                                      _c("textarea", {
                                        staticClass: "form-control",
                                        attrs: {
                                          rows: "5",
                                          placeholder: "Comment...",
                                        },
                                        domProps: { value: _vm.Comment },
                                        on: {
                                          input: function ($event) {
                                            return _vm.handleSavePanelistVoteCommentCommand(
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "mt-4",
                              staticStyle: { "min-height": "500px" },
                            },
                            [
                              _vm.votesEntries
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "PairwiseComparisonVotesBrowserView",
                                    },
                                    [
                                      _c(
                                        "ul",
                                        { staticClass: "nav nav-tabs" },
                                        [
                                          _c(
                                            "li",
                                            { staticClass: "nav-item" },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "nav-link",
                                                  class: {
                                                    active:
                                                      _vm.browserActiveTab ===
                                                      "votes",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.browserActiveTab =
                                                        "votes"
                                                    },
                                                  },
                                                },
                                                [_vm._v("Votes")]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "li",
                                            { staticClass: "nav-item" },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "nav-link",
                                                  class: {
                                                    active:
                                                      _vm.browserActiveTab ===
                                                      "summary",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.browserActiveTab =
                                                        "summary"
                                                    },
                                                  },
                                                },
                                                [_vm._v("Chart")]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "li",
                                            { staticClass: "nav-item" },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "nav-link",
                                                  class: {
                                                    active:
                                                      _vm.browserActiveTab ===
                                                      "comments",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.browserActiveTab =
                                                        "comments"
                                                    },
                                                  },
                                                },
                                                [_vm._v("Comments")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "tab-content" },
                                        [
                                          _vm.browserActiveTab === "votes"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "tab-pane pt-2",
                                                  class: {
                                                    active:
                                                      _vm.browserActiveTab ===
                                                      "votes",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "table-responsive",
                                                    },
                                                    [
                                                      _c(
                                                        "table",
                                                        {
                                                          staticClass:
                                                            "table table-striped",
                                                        },
                                                        [
                                                          _c("thead", [
                                                            _c("tr", [
                                                              _c("th", {
                                                                staticStyle: {
                                                                  "border-top":
                                                                    "0",
                                                                },
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "th",
                                                                {
                                                                  staticClass:
                                                                    "clearfix",
                                                                  staticStyle: {
                                                                    "min-width":
                                                                      "510px",
                                                                    "border-top":
                                                                      "0",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "clearfix pull-right",
                                                                      staticStyle:
                                                                        {
                                                                          width:
                                                                            "85%",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "pull-left",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.firstCriterionName
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "pull-right",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.secondCriterionName
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "text-center",
                                                                          staticStyle:
                                                                            {
                                                                              margin:
                                                                                "0 auto",
                                                                              width:
                                                                                "50px",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "vs"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                          ]),
                                                          _vm._v(" "),
                                                          _c(
                                                            "tbody",
                                                            [
                                                              _c(
                                                                "tr",
                                                                {
                                                                  staticStyle: {
                                                                    "text-align":
                                                                      "center",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "td",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          "text-align":
                                                                            "left",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "strong",
                                                                        [
                                                                          _vm._v(
                                                                            "Average (" +
                                                                              _vm._s(
                                                                                _vm.AverageDescription
                                                                              ) +
                                                                              ")"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "td",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          padding:
                                                                            "0",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "ul",
                                                                        {
                                                                          staticClass:
                                                                            "clearfix",
                                                                          staticStyle:
                                                                            {
                                                                              "list-style":
                                                                                "none",
                                                                              margin:
                                                                                "0",
                                                                              padding:
                                                                                "0",
                                                                            },
                                                                        },
                                                                        _vm._l(
                                                                          _vm.ScaleView1,
                                                                          function (
                                                                            scaleValue
                                                                          ) {
                                                                            return _c(
                                                                              "li",
                                                                              {
                                                                                class:
                                                                                  _vm.GetCssClass(
                                                                                    scaleValue,
                                                                                    _vm.Average
                                                                                  ),
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                                                " +
                                                                                    _vm._s(
                                                                                      _vm.GetScaleItemText(
                                                                                        scaleValue,
                                                                                        _vm.Average
                                                                                      )
                                                                                    ) +
                                                                                    "\n                                                            "
                                                                                ),
                                                                              ]
                                                                            )
                                                                          }
                                                                        ),
                                                                        0
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _vm._l(
                                                                _vm.VotesEntriesView,
                                                                function (
                                                                  voteEntry
                                                                ) {
                                                                  return _c(
                                                                    "tr",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          "text-align":
                                                                            "center",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "td",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              "text-align":
                                                                                "left",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                                        " +
                                                                              _vm._s(
                                                                                voteEntry.VotesSourceName
                                                                              ) +
                                                                              "\n                                                    "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "td",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              padding:
                                                                                "0",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "ul",
                                                                            {
                                                                              staticClass:
                                                                                "clearfix",
                                                                              staticStyle:
                                                                                {
                                                                                  "list-style":
                                                                                    "none",
                                                                                  margin:
                                                                                    "0",
                                                                                  padding:
                                                                                    "0",
                                                                                },
                                                                            },
                                                                            _vm._l(
                                                                              _vm.ScaleView1,
                                                                              function (
                                                                                scaleValue
                                                                              ) {
                                                                                return _c(
                                                                                  "li",
                                                                                  {
                                                                                    class:
                                                                                      _vm.GetCssClass(
                                                                                        scaleValue,
                                                                                        voteEntry.Value
                                                                                      ),
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                                                                " +
                                                                                        _vm._s(
                                                                                          _vm.GetScaleItemText(
                                                                                            scaleValue,
                                                                                            voteEntry.Value
                                                                                          )
                                                                                        ) +
                                                                                        "\n                                                            "
                                                                                    ),
                                                                                  ]
                                                                                )
                                                                              }
                                                                            ),
                                                                            0
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                            ],
                                                            2
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.browserActiveTab === "summary"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "tab-pane pt-2",
                                                  class: {
                                                    active:
                                                      _vm.browserActiveTab ===
                                                      "summary",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "table-responsive",
                                                    },
                                                    [
                                                      _c(
                                                        "table",
                                                        {
                                                          staticClass: "table",
                                                        },
                                                        [
                                                          _c("tbody", [
                                                            _c(
                                                              "tr",
                                                              {
                                                                staticClass:
                                                                  "bottom noborder",
                                                                staticStyle: {
                                                                  "text-align":
                                                                    "center",
                                                                },
                                                              },
                                                              _vm._l(
                                                                _vm.HistogramValues,
                                                                function (v) {
                                                                  return _c(
                                                                    "td",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          height:
                                                                            "400px",
                                                                          border:
                                                                            "none",
                                                                          "padding-top":
                                                                            "20px",
                                                                        },
                                                                    },
                                                                    [
                                                                      v.Count
                                                                        ? _c(
                                                                            "div",
                                                                            {
                                                                              domProps:
                                                                                {
                                                                                  innerHTML:
                                                                                    _vm._s(
                                                                                      v.Count
                                                                                    ),
                                                                                },
                                                                            }
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "bg-color-blue2",
                                                                          class:
                                                                            _vm.GetColor(
                                                                              v.Value
                                                                            ),
                                                                          style:
                                                                            {
                                                                              height: `${v.PercentOfMax}%`,
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "tr",
                                                              {
                                                                staticStyle: {
                                                                  "text-align":
                                                                    "center",
                                                                },
                                                              },
                                                              _vm._l(
                                                                _vm.HistogramScale,
                                                                function (hs) {
                                                                  return _c(
                                                                    "td",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          width:
                                                                            "6%",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                        " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .FormatValue(
                                                                                hs
                                                                              )
                                                                              .toFixedIfNeeded(
                                                                                2
                                                                              )
                                                                          ) +
                                                                          "\n                                                    "
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("tfoot", [
                                                            _c("tr", [
                                                              _c(
                                                                "th",
                                                                {
                                                                  staticStyle: {
                                                                    "text-align":
                                                                      "left",
                                                                  },
                                                                  attrs: {
                                                                    colspan:
                                                                      _vm.LeftScaleValuesCount,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                        " +
                                                                      _vm._s(
                                                                        _vm.firstCriterionName
                                                                      ) +
                                                                      "\n                                                    "
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "th",
                                                                {
                                                                  staticStyle: {
                                                                    "text-align":
                                                                      "center",
                                                                  },
                                                                },
                                                                [_vm._v("vs")]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "th",
                                                                {
                                                                  staticStyle: {
                                                                    "text-align":
                                                                      "right",
                                                                  },
                                                                  attrs: {
                                                                    colspan:
                                                                      _vm.RightScaleValuesCount,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                        " +
                                                                      _vm._s(
                                                                        _vm.secondCriterionName
                                                                      ) +
                                                                      "\n                                                    "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                          ]),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.browserActiveTab === "comments"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "tab-pane pt-2",
                                                  class: {
                                                    active:
                                                      _vm.browserActiveTab ===
                                                      "comments",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.Comments,
                                                  function (c) {
                                                    return _c(
                                                      "blockquote",
                                                      {
                                                        staticClass:
                                                          "blockquote",
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass: "mb-0",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(c.Comment)
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "footer",
                                                          {
                                                            staticClass:
                                                              "blockquote-footer",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                c.VotesSourceName
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.viewTemplate === "connecting" ? [_vm._m(0)] : _vm._e(),
      _vm._v(" "),
      _vm.viewTemplate === "notStarted"
        ? [
            _c(
              "div",
              {
                staticClass: "d-flex justify-content-center",
                staticStyle: { "padding-top": "200px" },
              },
              [
                _c("div", { staticClass: "card" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c("h5", { staticClass: "card-title" }, [
                      _vm._v("Meeting is not started"),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "card-text lead" }, [
                      _vm._v("Please wait for the host to start this meeting."),
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "sanitizedHref",
                            rawName: "v-sanitizedHref",
                            value: _vm.dashboardUrl,
                            expression: "dashboardUrl",
                          },
                        ],
                        staticClass: "btn btn-secondary",
                      },
                      [_vm._v("Go to the survey")]
                    ),
                  ]),
                ]),
              ]
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass: "d-flex justify-content-center",
        staticStyle: { "padding-top": "200px" },
      },
      [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("h5", { staticClass: "card-title" }, [
              _c("i", { staticClass: "fa fa-spinner fa-spin" }),
              _vm._v(" Connecting..."),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "card-text lead" }, [
              _vm._v("We are checking if meeting was started by the host."),
            ]),
            _c("br"),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }